import { useEffect } from "react";
import { useSelector } from "react-redux";

import userSelectors from "../../ducks/user/selectors";

import { setAxiosAndGqlToken } from "../../helpers/server";

function AppInit(props: any) {
  let localToken = useSelector(userSelectors.getToken);

  // Because this componet will not render too much
  // maybe we can leave the setting token here without
  // any worries.
  // in first render of app because we didn't
  // set axios token, basket request goes fail.
  setAxiosAndGqlToken(localToken);

  useEffect(() => {
    setAxiosAndGqlToken(localToken);
  }, [localToken]);

  return props.children;
}

export default AppInit;
